import React, { useRef, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Camera, Image as ImageIcon, Loader2 } from "lucide-react";
import { shrinkImage } from "../lib/image";

export async function readCard(f, onData) {
  try {
    const fd = new FormData(); fd.append("files", await shrinkImage(f));
    const { data } = await api.post("/customers/scan-cards", fd, { headers: { "Content-Type": "multipart/form-data" } });
    const it = (data.items || [])[0];
    if (!it || it.status === "okunamadi") toast.error("GÖRSEL OKUNAMADI — DAHA NET BİR GÖRÜNTÜ DENEYİN");
    else { onData(it.data); toast.success(it.status === "mukerrer" ? `OKUNDU — DİKKAT: KAYITLI OLABİLİR (${it.matched_firma})` : "OKUNDU — KONTROL EDİP KAYDEDİN"); }
  } catch (er) { toast.error(er.response?.data?.detail || "OKUMA HATASI"); }
}

export default function CardCapture({ onData }) {
  const cam = useRef(null);
  const gal = useRef(null);
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    const f = e.target.files?.[0]; e.target.value = "";
    if (!f) return;
    setBusy(true); await readCard(f, onData); setBusy(false);
  };
  return (
    <div data-testid="card-capture" className="grid grid-cols-2 gap-2">
      <button data-testid="card-camera-btn" disabled={busy} onClick={() => cam.current?.click()} className="flex h-14 items-center justify-center gap-2 rounded-xl bg-indigo-600 text-sm font-bold text-white active:scale-[0.98] disabled:opacity-60">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Camera className="h-5 w-5" />} {busy ? "OKUNUYOR..." : "KARTVİZİT ÇEK"}
      </button>
      <button data-testid="card-gallery-btn" disabled={busy} onClick={() => gal.current?.click()} className="flex h-14 items-center justify-center gap-2 rounded-xl border border-slate-700 bg-slate-800 text-sm font-bold text-slate-100 active:scale-[0.98] disabled:opacity-60">
        <ImageIcon className="h-5 w-5" /> GALERİDEN SEÇ
      </button>
      <input ref={cam} data-testid="card-camera-input" type="file" accept="image/*" capture="environment" className="hidden" onChange={go} />
      <input ref={gal} data-testid="card-gallery-input" type="file" accept="image/*" className="hidden" onChange={go} />
    </div>
  );
}
